import { render, staticRenderFns } from "./tree-select.vue?vue&type=template&id=59c88c72&scoped=true"
import script from "./tree-select.vue?vue&type=script&lang=js"
export * from "./tree-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c88c72",
  null
  
)

export default component.exports